import React, { memo } from "react";
import styled from "styled-components";

export interface IProps {
  text: string;
  type?: string;
  mandatory?: boolean | false;
  extraText?: string | null;
}

export interface IStyle {
  type?: string;
}

const TitleWrapper = styled.div<IStyle>`
  position: relative;
  width: fit-content;
  background-color: ${(props) => props.theme.backgroundTransparentWhite};
  border-radius: 4px 4px 0 0;
  color: ${(props) => props.theme.textColorDarken};
  text-transform: uppercase;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 14px;
  padding: 12px 16px;
`;
const ExtraText = styled.span`
  font-size: 10px;
  display: block;
  font-style: italic;
  text-transform: none;
  margin-top: 2px;
  margin-bottom: -8px;
`;
const TitleLayout = (props: IProps) => {
  return (
    <TitleWrapper data-test="title" type={props.type}>
      {props.text}
      {props.mandatory && " *"}
      {props.extraText && (
        <ExtraText data-test="extra-text">{props.extraText}</ExtraText>
      )}
    </TitleWrapper>
  );
};

export const Title = memo(TitleLayout);
